export default __webpack_public_path__ + "static/media/image-35.788e8497.png";